import React from 'react'
import { Link } from 'react-router-dom'
import TierIcon from './TierIcon'
import {
    STAGE_LABELS, LATE_LABELS,
    formatBarcode, formatDateTime, formatDeadline, formatDesigner, orNothing,
} from './embroideryFormat'

export const BatchLink = ({ batchId, children }) => (
    batchId
        ? <Link to={`/batches/${batchId}`} target='_blank'>{children}</Link>
        : <span>{children}</span>   // chưa phân lô: text thường, không link (BR-4.1)
)

const StageCell = ({ item }) => (
    <span>
        <span className='stagePill'>{STAGE_LABELS[item.stage]}</span>
        {item.late_hours !== null && item.late_hours !== undefined && (
            <span className='lateTag'>{`${LATE_LABELS[item.stage]} ${item.late_hours}h`}</span>
        )}
    </span>
)

const DeadlineCell = ({ item }) => (
    <span className={`deadline tier-${item.deadline_tier}`}>
        <TierIcon type={item.deadline_tier} />
        {formatDeadline(item)}
    </span>
)

const HEADERS = [
    'Barcode item', 'SKU', 'Size', 'Lô', 'Công đoạn', 'Partner', 'Hạn sản xuất',
    'Người thiết kế', 'Người thêu', 'Vào lô lúc', 'Thời gian thiết kế', 'Thời gian thêu',
]

// Bảng 12 cột theo FR-004
const EmbroideryItemsTable = ({ items }) => (
    <div className='EmbroideryItemsTableWrap'>
        <table className='table EmbroideryItemsTable'>
            <thead>
                <tr>{HEADERS.map((h) => <th key={h}>{h}</th>)}</tr>
            </thead>
            <tbody>
                {items.length === 0 && (
                    <tr>
                        <td colSpan={HEADERS.length} className='text-center empty'>
                            Không có item nào khớp bộ lọc. Bỏ bớt điều kiện lọc để xem thêm.
                        </td>
                    </tr>
                )}
                {items.map((item) => (
                    <tr key={String(item.order_id)}>
                        <td className='mono'><BatchLink batchId={item.batch_id}>{formatBarcode(item)}</BatchLink></td>
                        <td>{item.sku}</td>
                        <td>{orNothing(item.size)}</td>
                        <td className='mono'>{item.batch_id ? <BatchLink batchId={item.batch_id}>{item.batch_name}</BatchLink> : <span className='text-muted'>Chưa phân lô</span>}</td>
                        <td><StageCell item={item} /></td>
                        <td>{orNothing(item.partner_name)}</td>
                        <td><DeadlineCell item={item} /></td>
                        <td>{formatDesigner(item.user_designed)}</td>
                        <td>{orNothing(item.user_embroidered)}</td>
                        <td className='time'>{formatDateTime(item.entered_batch_at)}</td>
                        <td className='time'>{formatDateTime(item.designed_at)}</td>
                        <td className='time'>{formatDateTime(item.embroidered_at)}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
)

export default EmbroideryItemsTable
